import React from 'react';

const EMPTY_PREVIEW =
  '<!DOCTYPE html><html><head><meta charset="utf-8"></head><body style="font-family:sans-serif;padding:16px;color:#64748b;">No HTML to preview.</body></html>';

type EmailHtmlPreviewProps = {
  html: string;
  className?: string;
  minHeight?: number;
};

/**
 * Renders email HTML in a sandboxed iframe.
 * SECURITY: this content can be user-authored (campaign / automation HTML), so it
 * must never run scripts with the admin's session. `sandbox` without
 * allow-scripts / allow-same-origin gives it an opaque origin; images, styles
 * and links still render normally.
 */
const EmailHtmlPreview: React.FC<EmailHtmlPreviewProps> = ({
  html,
  className = '',
  minHeight = 360,
}) => {
  const payload = (html || '').trim();

  return (
    <iframe
      title="Email HTML preview"
      className={className}
      srcDoc={payload || EMPTY_PREVIEW}
      sandbox="allow-popups allow-popups-to-escape-sandbox"
      style={{ width: '100%', minHeight, display: 'block', background: '#ffffff' }}
    />
  );
};

export default EmailHtmlPreview;
